import Shepherd from 'shepherd.js';
import { TOUR_BUTTONS } from '../shepherd-defaults';
import { waitForElement } from '../shepherd.utils';

type ShepherdTour = InstanceType<typeof Shepherd.Tour>;

export const MESSAGES_GROUP_CHAT_TOUR = 'messages-group-chat';

export function isMessagesGroupChatsSkeletonVisible(): boolean {
  return !!document.querySelector('#group-chats-pane .message-item.skeleton-loader');
}

export function isGroupChatsTabActiveInDom(): boolean {
  return !!document.querySelector('#group-chats-tab.active') && !!document.querySelector('#group-chats-pane.active');
}

/**
 * Messages → Group Chat tab: optional empty-state step, then create-group icon, then header notification bell.
 */
export function buildMessagesGroupChatTour(tour: ShepherdTour): void {
  const empty = !!document.querySelector('[data-tour="messages-group-chats-empty-area"]');

  if (empty) {
    tour.addStep({
      id: 'messages-group-chats-empty',
      title: 'Tip',
      text: 'Be the first golfer to start the conversation.',
      attachTo: { element: '[data-tour="messages-group-chats-empty-area"]', on: 'top' },
      buttons: [TOUR_BUTTONS.skip, TOUR_BUTTONS.next],
      canClickTarget: true,
      beforeShowPromise() {
        return waitForElement('[data-tour="messages-group-chats-empty-area"]', 8000).then(() => undefined);
      },
    });
  }

  tour.addStep({
    id: 'messages-group-chats-create-icon',
    title: 'Tip',
    text: 'Tap here to create a new group chat.',
    attachTo: { element: '[data-tour="messages-group-chats-create-icon"]', on: 'bottom' },
    buttons: empty ? [TOUR_BUTTONS.back, TOUR_BUTTONS.next] : [TOUR_BUTTONS.skip, TOUR_BUTTONS.next],
    canClickTarget: true,
    beforeShowPromise() {
      return waitForElement('[data-tour="messages-group-chats-create-icon"]', 8000).then(() => undefined);
    },
  });

  tour.addStep({
    id: 'messages-group-chats-notifications',
    title: 'Tip',
    text: 'Enable notifications so you never miss updates. Tap the bell, then the gear icon to open notification settings.',
    attachTo: { element: '[data-tour="header-notification-bell"]', on: 'bottom' },
    buttons: [TOUR_BUTTONS.back, TOUR_BUTTONS.finish],
    canClickTarget: true,
    beforeShowPromise() {
      return waitForElement('[data-tour="header-notification-bell"]', 8000).then(() => undefined);
    },
  });
}
